import { fetch, postData, putData, deleteFunction } from "../../../Component/function/FunctionApi";

const ENDPOINT = "CompanyCapital";

const buildQueryUrl = (base, params = {}) => {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      cleaned[key] = value;
    }
  });
  const query = new URLSearchParams(cleaned).toString();
  return query ? `${base}?${query}` : base;
};

const companyCapitalService = {
  // GET /api/CompanyCapital
  getAll: async (params = {}) => {
    const url = buildQueryUrl(ENDPOINT, params);
    return await fetch(url);
  },

  // GET /api/CompanyCapital/{id}
  getById: async (id) => {
    return await fetch(`${ENDPOINT}/${id}`);
  },

  // GET /api/CompanyCapital/Summary
  getSummary: async () => {
    return await fetch(`${ENDPOINT}/Summary`);
  },

  // POST /api/CompanyCapital
  create: async (payload, setError = () => {}) => {
    const response = await postData(ENDPOINT, payload, setError);
    return response?.data;
  },

  // PUT /api/CompanyCapital/{id}
  update: async (id, payload, setError = () => {}) => {
    const response = await putData(`${ENDPOINT}/${id}`, payload, setError);
    return response?.data;
  },

  // DELETE /api/CompanyCapital/{id}
  remove: async (id) => {
    const response = await deleteFunction(`${ENDPOINT}/${id}`);
    return response?.data;
  },
};

export default companyCapitalService;